export const extractFormFieldHelperProps = (props) => {
    var _a, _b;
    return ({
        errorNotification: Object.assign({ show: !!((_a = props.errorNotification) === null || _a === void 0 ? void 0 : _a.message) }, props.errorNotification),
        contextualHelp: Object.assign({ show: !!((_b = props.contextualHelp) === null || _b === void 0 ? void 0 : _b.content) &&
                props.contextualHelp.variant === 'stacked' }, props.contextualHelp),
        nativeDescribedBy: props['aria-describedby'],
    });
};
const formTextPropsToFilter = [
    'variant',
    'labelContent',
    'contextualHelp',
    'className',
];
export const filterFormTextProps = (props) => {
    return Object.entries(props).reduce((acc, current) => {
        const key = current[0];
        const value = current[1];
        if (formTextPropsToFilter.includes(key))
            return acc;
        return Object.assign(Object.assign({}, acc), { [key]: value });
    }, {});
};
const textAreaPropsToFilter = [
    'children',
    'errorNotification',
    'characterCounter',
    'resizable',
    'ref',
];
export const filterTextAreaProps = (props) => {
    return Object.entries(props).reduce((acc, current) => {
        const key = current[0];
        const value = current[1];
        if (textAreaPropsToFilter.includes(key))
            return acc;
        return Object.assign(Object.assign({}, acc), { [key]: value });
    }, {});
};
//# sourceMappingURL=utils.js.map